<template>
  <div>
    <cabecalho :ar="ar"></cabecalho>
    <div class="app-content">
      <div class="heading">Agendamento de validação cadastral</div>
      <b-card class="shadow-sm mb-2 bg-white rounded">

        <font-awesome-icon icon="check-circle" style="color:#008550;" size="lg" />
        Agendamento realizado!
      </b-card>
    <b-card v-if="selectedRoomName && selectedEvent" class="shadow-sm mb-2 bg-white rounded">
      <div class="d-block" style="color:var(--main-color-darker-alpha8);">
        Agendado para:
        <br />
        <span class="font-weight-bold">{{selectedRoomName}}</span>
        <br />
        <span class="font-weight-bold">{{selectedEvent.dataInicialFormatada.substring(8,10) + '/' + selectedEvent.dataInicialFormatada.substring(5,7) + '/' + selectedEvent.dataInicialFormatada.substring(0,4)}} às {{selectedEvent.dataInicialFormatada.substring(11,16)}}</span>
        <br />
        <span class="font-weight-bold">A tolerância máxima de atraso é de 10 minutos a partir da hora agendada.</span>
      </div>
      <p class="mt-2">Em breve, você receberá um e-mail com maiores informações sobre a emissão do seu certificado digital.</p>

    </b-card>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";

export default {
  components: {
    cabecalho
  },
  data() {
    return {

    };
  },
  computed: {
    ar: function() {
      var arAndCertificate = sessionStorage.getItem("arAndCertificate");
      if (arAndCertificate != null) {
        return JSON.parse(arAndCertificate);
      }
      return null;
    },
    selectedRoomName: function() {
      var roomName = sessionStorage.getItem("selectedRoomName");
      if (roomName != null) {
        return roomName;
      }
      return null;
    },
    selectedEvent: function() {
      var evento = sessionStorage.getItem("selectedEvent");
      if (evento != null) {
        return JSON.parse(evento);
      }
      return null;
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/ScheduleSuccess.vue